const Level3 = ({
  currentImage,
  L0OuterL2,
  L0OuterL4,
  L0OuterL5,
  L0OuterL6,
  L3Business,
  L3Core,
  L3Leadership,
  L3Self,
}) => {
  return (
    <div className={`${currentImage !== "imagedivl3" ? "hidden" : ""}`}>
      <div className="" id="imagedivl3">
        <div>
          <img
            src="assets/images/outerL3 1.png"
            useMap="#lw03"
            alt=""
            className="w-80 h-80"
          />
          <map name="lw03" id="lw03">
            <area
              className="cursor-pointer"
              alt="L3 Outer L2"
              onClick={L0OuterL2}
              coords="522,1208,543,1102,439,1076,359,1033,289,981,238,924,145,989,200,1057,280,1120,399,1178"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L3 Outer L6"
              onClick={L0OuterL6}
              coords="10,649,119,647,123,569,135,502,153,432,180,379,225,315,271,256,304,230,208,161,141,227,98,296,54,374,17,500"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L3 Outer L5"
              onClick={L0OuterL5}
              coords="297,96,362,196,434,157,517,133,615,127,707,134,760,145,809,36,725,15,604,8,462,24"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L3 Outer L4"
              onClick={L0OuterL4}
              coords="984,133,912,226,986,298,1041,377,1072,444,1095,550,1227,550,1215,478,1170,358,1086,219"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L3 Business"
              onClick={L3Business}
              coords="839,833,1053,618,618,619,839,835"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L3 Self"
              onClick={L3Self}
              coords="611,1051,614,618,394,840"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L3 Leadership"
              onClick={L3Leadership}
              coords="176,613,389,394,605,610"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L3 Core"
              onClick={L3Core}
              coords="614,612,618,178,827,391"
              shape="poly"
            />
          </map>
        </div>
      </div>
    </div>
  );
};

export default Level3;
